"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const core_1 = require("@material-ui/core");
const Button_1 = __importDefault(require("../Button"));
const detalhes_1 = __importDefault(require("./detalhes"));
const styles_1 = require("./styles");
const LayoutColunaInfo = ({ backgroundConteudo, headerMobile, btnBackClickHandler, formJustifyContent, formAlignItems, formJustifyContentMobile, formAlignItemsMobile, children, }) => {
    return (react_1.default.createElement(styles_1.ContainerStyled, null,
        headerMobile && react_1.default.createElement(core_1.Hidden, { mdUp: true }, headerMobile),
        react_1.default.createElement(styles_1.ContentStyled, null,
            react_1.default.createElement(styles_1.FormContentStyled, { formJustifyContent: formJustifyContent, formAlignItems: formAlignItems, formJustifyContentMobile: formJustifyContentMobile, formAlignItemsMobile: formAlignItemsMobile },
                btnBackClickHandler && (react_1.default.createElement(styles_1.BackButtonContainerStyled, null,
                    react_1.default.createElement(Button_1.default, { name: "botao-voltar", rounded: true, onClick: btnBackClickHandler },
                        react_1.default.createElement(styles_1.ArrowBackIconStyled, null)))),
                children),
            react_1.default.createElement(styles_1.BackgroundContainerStyled, null, backgroundConteudo ? backgroundConteudo : react_1.default.createElement(detalhes_1.default, null)))));
};
exports.default = LayoutColunaInfo;
//# sourceMappingURL=index.js.map